import { createFileRoute } from "@tanstack/react-router";
import { EsLegalPage, EsLegalSection } from "@/components/site/EsPage";
import { buildHead } from "@/lib/seo-head";
import { LicensingDisclosure } from "@/components/site/LicensingDisclosure";

export const Route = createFileRoute("/es/legal/licencias")({
  head: () =>
    buildHead({
      title: "Licencias y Divulgaciones — Simply Approved Mortgages",
      description:
        "Dónde tiene licencia Simply Approved Mortgages LLC (NMLS #2620881): Florida y Colorado. Cómo verificar nuestra licencia y divulgaciones publicitarias.",
      url: "/es/legal/licencias",
      locale: "es",
      breadcrumbs: [
        { name: "Inicio", url: "/es" },
        { name: "Licencias", url: "/es/legal/licencias" },
      ],
    }),
  component: Page,
});

function Page() {
  return (
    <EsLegalPage
      title="Licencias y divulgaciones"
      intro="Simply Approved Mortgages LLC (NMLS #2620881) es un corredor hipotecario. Gestionamos préstamos hipotecarios residenciales a consumidores únicamente en Florida y Colorado."
      enPath="/legal/licensing"
      enLabel="Licensing"
    >
      <EsLegalSection heading="Divulgación legal y de licencias completa">
        <LicensingDisclosure locale="es" className="text-sm leading-relaxed text-muted-foreground" headingClassName="sr-only" />
      </EsLegalSection>
      <EsLegalSection heading="Estados donde originamos">
        <p>
          Originamos préstamos hipotecarios residenciales a consumidores solo en{" "}
          <strong>Florida</strong> y <strong>Colorado</strong>. En cualquier otro estado, el
          contenido de este sitio es únicamente material educativo y de investigación para
          inversionistas: no solicitamos negocio hipotecario residencial a consumidor, no aceptamos
          solicitudes residenciales y no originamos préstamos residenciales allí.
        </p>
        <p>
          Los programas de préstamos DSCR y con fines comerciales (business-purpose) para
          propiedades de inversión están disponibles para entidades (LLC, LP, corporaciones) en
          jurisdicciones adicionales donde la ley lo permite, siempre como transacciones con fines
          comerciales y no residenciales a ocupantes-propietarios.
        </p>
      </EsLegalSection>

      <EsLegalSection heading="Verifique nuestra licencia">
        <p>
          Puede verificar nuestras licencias en NMLS Consumer Access:{" "}
          <a
            href="https://www.nmlsconsumeraccess.org/EntityDetails.aspx/COMPANY/2620881"
            target="_blank"
            rel="noopener noreferrer"
            className="font-semibold text-brand hover:underline"
          >
            nmlsconsumeraccess.org
          </a>
          .
        </p>
        <ul className="mt-2 list-disc pl-5">
          <li>Simply Approved Mortgages LLC — NMLS #2620881</li>
          <li>Florida Mortgage Broker License #MBR7685</li>
          <li>Colorado Mortgage Company Registration</li>
        </ul>
      </EsLegalSection>

      <EsLegalSection heading="Divulgación publicitaria de Florida">
        <p>
          Los anuncios de préstamos hipotecarios en Florida deben ser veraces, no engañosos, y no
          deben prometer términos que no puedan hacerse disponibles para un número razonable de
          solicitantes calificados. Las tasas, pagos, puntos, comisiones y términos mostrados son
          ilustrativos y sujetos a cambio; los términos reales dependen de la aprobación del
          prestamista mayorista, la propiedad, el crédito y otros factores.
        </p>
      </EsLegalSection>

      <EsLegalSection heading="Divulgación publicitaria de Colorado">
        <p>
          Cada anuncio de préstamo hipotecario dirigido a consumidores de Colorado identifica a
          Simply Approved Mortgages LLC, NMLS #2620881, como la compañía hipotecaria, y muestra el
          teléfono de negocios. Los términos anunciados están sujetos a limitaciones materiales y a
          la elegibilidad del solicitante. Conservamos copias de los anuncios de Colorado por al
          menos cuatro años.
        </p>
      </EsLegalSection>
    </EsLegalPage>
  );
}
